import Component from "@base/js/component";

export default class PersonLandingPage extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".person-landing-page";

  // Defines children that needs to be queried as part of this component
  static children = {
    // body: ".person-landing-page__body" // Queries a single element
    // items: [".person-landing-page__items"] // Queries a an array of elements
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    // body: {
    //  click: this.onBodyClick // Attaches onBodyClick method to this.children.body
    // }
  };

  // constructor() {
  //   super();
  // }

  // Will be called upon component instantiation
  afterInit() {
    /* eslint-disable no-console */
    console.log(`Component initialized`, this.element);
    /* eslint-enable no-console */
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
PersonLandingPage.init();
